// Expert chunks
import store from "@/store";

const Cases = () =>
  import(
    /* webpackChunkName: "expert" */
    "@/views/Expert/Cases/index"
  );

const Case = () =>
  import(
    /* webpackChunkName: "expert" */
    "@/views/Expert/Cases/Case/index"
  );

const Overview = () =>
  import(
    /* webpackChunkName: "expert" */
    "@/components/Expert/Case/Overview/index"
  );
const CompanyProfile = () =>
  import(
    /* webpackChunkName: "expert" */
    "@/components/Expert/Case/CompanyProfile/index"
  );
const CaseProfile = () =>
  import(
    /* webpackChunkName: "expert" */
    "@/components/Expert/Case/CaseProfile/index"
  );
const Candidate = () =>
  import(
    /* webpackChunkName: "expert" */
    "@/components/Expert/Case/Candidate/index"
  );
const Documents = () =>
  import(
    /* webpackChunkName: "expert" */
    "@/components/Expert/Case/Documents/index"
  );
const OnlineApplication = () =>
  import(
    /* webpackChunkName: "expert" */
    "@/components/Expert/Case/OnlineApplication/index"
  );
const CoverLetter = () =>
  import(
    /* webpackChunkName: "expert" */
    "@/components/Expert/Case/CoverLetter/index"
  );

const expertRoutes = [
  {
    path: "/expert/cases",
    name: "expert-cases",
    component: Cases,
    meta: {
      auth: "expert",
      title: "Expert cases",
    },
    beforeEnter: (to, from, next) => {
      store.dispatch("expert/refreshData");
      next();
    },
  },

  {
    path: "/expert/cases/:case_id",
    name: "expert-case",
    component: Case,
    children: [
      {
        path: "overview",
        component: Overview,
        meta: {
          auth: "expert",
          title: "Case",
        },
      },
      {
        path: "company_profile",
        component: CompanyProfile,
        meta: {
          auth: "expert",
          title: "Case",
        },
      },
      {
        path: "case_profile",
        component: CaseProfile,
        meta: {
          auth: "expert",
          title: "Case",
        },
      },
      {
        path: "candidate",
        component: Candidate,
        meta: {
          auth: "expert",
          title: "Case",
        },
      },
      {
        path: "documents",
        component: Documents,
        meta: {
          auth: "expert",
          title: "Case",
        },
        beforeEnter: (to, from, next) => {
          if (store.getters["usercase/currentUsercase"])
            store.dispatch("usercase/sponsorship/refreshDocuments");
          next();
        },
      },
      {
        path: "cover_letter",
        component: CoverLetter,
        meta: {
          auth: "expert",
          title: "Case",
        },
      },
      {
        path: "online_application",
        component: OnlineApplication,
        meta: {
          auth: "expert",
          title: "Case",
        },
      },
    ],
    meta: {
      auth: "expert",
      title: "Case",
    },
    beforeEnter: (to, from, next) => {
      if (to.params.case_id) {
        store.dispatch(
          "expert/usercase/refreshUsercaseByID",
          to.params.case_id
        );
      }
      next();
    },
  },
];

export default expertRoutes;
